<template>
  <v-app>
    <template v-if="!loggedIn && !loading">
      <LoginView @currentUser="handleUser"></LoginView>
    </template>

    <template v-else-if="!loading">
      <v-app-bar app>
        <template v-slot:prepend>
          <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        </template>
        <v-toolbar-title v-if="$vuetify.display.smAndDown">Steadfast Management App</v-toolbar-title>
        <template v-slot:append>
          <div class="text-right" v-if="$vuetify.display.mdAndUp">
            <p>Logged in as</p>
            <p class="font-weight-bold">{{ user.name }}</p>
          </div>
          <v-btn icon="mdi-logout" @click="logOutUser()"></v-btn>
        </template>
      </v-app-bar>
      <v-navigation-drawer
        v-model="drawer"
        :permanent="$vuetify.display.mdAndUp"
        :temporary="$vuetify.display.smAndDown"
        class="bg-grey-lighten-1"
      >
        <div class="logo-container">
          <img class="logo" src="./assets/logo.png" />
        </div>
        <v-list color="transparent">
          <v-list-item @click="$router.push('/')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">home</span>&nbsp; Home
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/projects')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">apartment</span
              >&nbsp; Projects
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/units')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">house</span>&nbsp; Units
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/tenants')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">person</span>&nbsp; Tenants
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/owners')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">passkey</span
              >&nbsp; Owners
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/rooms')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">bed</span>&nbsp; Rooms
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/tenancies')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">date_range</span>&nbsp; Tenancies
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/accesscards')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">badge</span
              >&nbsp; Access Cards
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/parkingslots')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">emoji_transportation</span
              >&nbsp; Parking Slots
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/payments')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">payments</span
              >&nbsp; Payments
            </div>
          </v-list-item>
          <v-list-item @click="$router.push('/messaging')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">chat</span
              >&nbsp; Messaging API
            </div>
          </v-list-item>
           <v-list-item @click="$router.push('/datapopulation')">
            <div class="d-flex align-center">
              <span class="material-symbols-outlined">database</span
              >&nbsp; Data Population
            </div>
          </v-list-item>
        </v-list>

        <!-- <template v-slot:append>
          <div class="d-flex flex-column">
            <v-divider></v-divider>
            <p class="text-center">Logged in as</p>
            <p class="text-center font-weight-bold">{{ user.name }}</p>
            <v-btn class="bg-grey-darken-4" @click="logOutUser()"> Logout </v-btn>
          </div>
        </template> -->
      </v-navigation-drawer>
      <v-main class="ma-5"><RouterView /></v-main>
    </template>

    <template v-else-if="loading">
      <div class="d-flex justify-center align-center h-screen">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </template>

  </v-app>
</template>

<script>
import LoginView from './components/LoginView.vue';
import firebaseconfig from '../firebase.config';
import { getDocs, query, collection, where } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, setPersistence, browserLocalPersistence, signOut } from 'firebase/auth';

export default {
  data(){
    return {
      loggedIn : false,
      users: [],
      user: {},
      loading: true, // Keep loading true initially
      drawer: false, // Initialized to false, will be set by watch or mounted
    }
  },
  watch: {
    '$vuetify.display.mdAndUp'(isMdAndUp) {
      // This will only run after this.$vuetify is available
      if (isMdAndUp) {
        this.drawer = true; // Automatically open the drawer on desktop
      } else {
        this.drawer = false; // Close the drawer on mobile/tablet
      }
    },
    // Also watch loggedIn status to potentially update drawer state if necessary
    loggedIn(newVal) {
      if (newVal && this.$vuetify && this.$vuetify.display.mdAndUp) {
        // If just logged in and on desktop, ensure drawer is open
        this.drawer = true;
      } else if (!newVal && this.$vuetify) {
        // If just logged out, ensure drawer is closed
        this.drawer = false;
      }
    }
  },
  components: {
    LoginView: LoginView
  },
  methods: {
    async handleUser(user) {
      const usersRef = collection(firebaseconfig.db, 'users');
      const q = query(usersRef, where('uid', '==', user.uid));
      const querySnapshot = await getDocs(q);
      this.users = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
      }));
      this.user = this.users[0];
      this.loggedIn = true;
    },
    async checkAuthState() {
      const auth = getAuth();

      // Ensure authentication persistence
      await setPersistence(auth, browserLocalPersistence);

      onAuthStateChanged(auth, async (user) => {
        if (user) {
          await this.handleUser(user);
          // Don't set loggedIn = true here again, handleUser already does it
        } else {
          this.loggedIn = false;
        }
        this.loading = false; // Hide loading screen after auth state check
      });
    },
    async logOutUser() {
      const auth = getAuth();
        try {
          await signOut(auth);
          this.loggedIn = false;
          this.user = {};
          this.$router.push('/'); // Optional: Redirect to home or login after logout
        } catch (error) {
          console.error("Logout failed:", error);
        }
    }
  },
  created() {
    this.checkAuthState();
  },
  mounted() {
    // Set initial drawer state based on current screen size ONLY AFTER VUETIFY IS MOUNTED
    // This is a safer place for initial access to this.$vuetify.display
    if (this.$vuetify && this.$vuetify.display.mdAndUp) {
      this.drawer = true;
    }
  }
};
</script>

<style scoped>
.logo-container{
    width: 100%;
    text-align: center;
  }

.logo{
  width: 200px;
  margin-top: 20px;
  border-radius: 10px;
}

/* Optional: Basic styling for the loading spinner */
.h-screen {
  height: 100vh;
}
</style>